import api from "./api.service";
import type { LoginPayload, AuthResponse, AuthUser } from "@/models/auth.model";

const AuthService = {
  async login(payload: LoginPayload): Promise<AuthResponse> {
    const { data } = await api.post<AuthResponse>("/auth/login", payload);
    localStorage.setItem("token", data.token);
    localStorage.setItem("user", JSON.stringify(data.user));
    return data;
  },

  async logout(): Promise<void> {
    // 1) Invalider le token côté backend (non bloquant)
    try { await api.post("/auth/logout"); } catch { /* ignore */ }
    // 2) Nettoyage complet du stockage local (token, user, préférences, caches)
    try { localStorage.clear(); } catch { /* ignore */ }
    try { sessionStorage.clear(); } catch { /* ignore */ }
    // 3) Purger les en-têtes d'authentification en mémoire
    try { delete (api.defaults.headers as any).common?.Authorization; } catch { /* ignore */ }
  },

  async verify(): Promise<boolean> {
    try {
      await api.get("/auth/verify");
      return true;
    } catch {
      return false;
    }
  },

  async me(): Promise<AuthUser> {
    const { data } = await api.get<{ user: AuthUser }>("/auth/me");
    return data.user;
  },

  getUserFromStorage(): AuthUser | null {
    const raw = localStorage.getItem("user");
    return raw ? JSON.parse(raw) : null;
  },
};

export default AuthService;
